import AddAdyenCardModal from './AddAdyenCardModal';

export default {
  AddAdyenCardModal,
};
